<template>
  <div class="provider">
    <div v-if="isWallet">
      <img src="@/assets/scatter-invert.svg" />
      <p class="m-b-8 m-t-16 has-text-weight-bold f-12 is-ls-2 is-uppercase">{{this.$t('wallet.connectTo')}} {{name}}</p>
      <p class="text f-14" > {{this.$t('wallet.weUse')}} <span class="has-text-primary">{{getProvidersList}}</span> <span v-html="this.$t('wallet.scatterInfoPhrase')"></span></p>
      <button class="button is-primary m-t-16"
          @click="connect(id)"
          :class="{'is-loading': connecting}">
          <span v-if="!connecting" class="h-icon" :class="'icon-' + id"></span>
          {{this.$t('wallet.connectTo')}} {{name}}
      </button>
    </div>
    <div v-else class="m-b-8">
      <p class="m-b-8">{{this.$t('wallet.connectTo')}} {{name}}</p>
      <button class="button is-primary"
          @click="connect(id)"
          :class="{'is-loading': connecting}">
          <span v-if="!connecting" class="h-icon" :class="'icon-' + id"></span>
          {{this.$t('wallet.connectTo')}} {{name}}
      </button>
      <p class="m-t-8 text f-12" > {{this.$t('wallet.weUse')}} <span class="has-text-primary">{{getProvidersList}}</span> <span v-html="this.$t('wallet.scatterInfoPhrase')"></span></p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    isWallet: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('sigproviders', [
      'connecting',
      'connected'
    ]),
    getProvidersList () {
      const prods = []
      this.providers.forEach(p => {
        prods.push(p.meta.shortName)
      })
      return prods.join(', ')
    },
    ...mapGetters('sigproviders', [
      'providers',
      'account'
    ])
  },
  methods: {
    connect (walletId) {
      this.$store.dispatch('sigproviders/attachWallet', walletId)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/wallet/provider.vue